import { PhoneNumberDisplay } from "@components/phoneNumber/PhoneNumberDisplay";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";

export const PhoneNumberCell = <T extends { phoneNumber: string | null }>({
    row,
}: CellContext<ViewTableFeatures, T, string>) => {
    const phoneNumber = row.original.phoneNumber;

    if (!phoneNumber) {
        return null;
    }

    return (
        <span>
            <PhoneNumberDisplay phoneNumber={phoneNumber} />
        </span>
    );
};
